import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { BankState } from '@klopotun/contracts';
import { bankQueries } from './bank-queries.js';

export const useBankStateQuery = (): UseQueryResult<BankState> => useQuery(bankQueries.state());
